
import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { WabisabiIcon } from "@/components/common/WabisabiIcon";

interface WabisabiPhilosophyScreenProps {
  onContinue: () => void;
}

const WabisabiPhilosophyScreen: React.FC<WabisabiPhilosophyScreenProps> = ({ onContinue }) => {
  return (
    <Card className="w-full max-w-md mx-auto">
      <CardHeader className="text-center pb-6">
        <div className="flex justify-center mb-6">
          <WabisabiIcon 
            size={72}
          />
        </div>
        <h1 className="text-2xl font-bold text-[#6C4F77] mb-2">
          Relationships are beautifully imperfect
        </h1>
        <p className="text-lg text-[#6C4F77]/80 font-medium">
          And that's exactly what makes them precious
        </p>
      </CardHeader>
      
      <CardContent className="space-y-6 text-center">
        <div className="space-y-4">
          <p className="text-[#2C2C2C] leading-relaxed">
            We believe forgetting is human, not failure. This app helps you remember what matters without judging what you miss.
          </p>
          
          <p className="text-[#2C2C2C] leading-relaxed">
            Let's find beauty in everyday moments together.
          </p>
        </div>
        
        <div className="pt-4">
          <Button 
            onClick={onContinue}
            className="w-full bg-[#6C4F77] hover:bg-[#6C4F77]/90"
            size="lg"
          >
            Begin my journey
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default WabisabiPhilosophyScreen;
